import CriticalIcon from '@assets/svg/danger.svg';
import Logo from '@assets/svg/white-logo.svg';
import { useAuth0 } from '@auth0/auth0-react';
import { setExpirationDateTime } from '@store/redux/features/organization';
import { useAppDispatch } from '@store/redux/store';
import {
  Body,
  Container,
  Description,
  LogoHeader,
  LogoImg,
  StyledImg,
  TitleResult,
} from './Expired.styles';

const Expired = () => {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();
  setTimeout(() => {
    dispatch(setExpirationDateTime(undefined));
    logout();
  }, 5000);
  return (
    <Container>
      <Body>
        <LogoHeader>
          <LogoImg src={Logo} alt="icon" />
        </LogoHeader>
        <StyledImg src={CriticalIcon} alt="icon" />

        <div style={{ height: 32 }} />

        <TitleResult>Sorry, your trial has expired.</TitleResult>

        <Description>
          A customer success manager will reach out to you shortly.
        </Description>
      </Body>
    </Container>
  );
};

export { Expired };
